// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VoiceViz_wrapper__1j_Er","packsWrapper":"VoiceViz_packsWrapper__1K0_f"};